import { getDocument } from 'ssr-window';
// STRICT - @ts-expect-error - to be typed
import EnvironmentUtils from '@spothero/utils/environment';
export const getMediaSource = () => {
    const document = getDocument();
    const isBrowser = EnvironmentUtils.isBrowser();
    if (!isBrowser) {
        return 'Other';
    }
    // NOTE: In some cases, IE11 doesn't set document.referrer (or sets it to an empty string), so we can't destructure this.
    const search = (s) => document.referrer.search(s);
    if (search('https?://(.*)google.([^/?]*)') === 0) {
        return 'Google';
    }
    else if (search('https?://(.*)bing.([^/?]*)') === 0) {
        return 'Bing';
    }
    else if (search('https?://(.*)yahoo.([^/?]*)') === 0) {
        return 'Yahoo';
    }
    else if (search('https?://(.*)facebook.([^/?]*)') === 0) {
        return 'Facebook';
    }
    else if (search('https?://(.*)twitter.([^/?]*)') === 0) {
        return 'Twitter';
    }
    else {
        return 'Other';
    }
};
